import { useTranslation } from 'react-i18next'
import Loading from '@/widgets/Loading'
import AvailabilityForm from '../common/AvailabilityForm'
import useDyspozycjaEdit from './hooks/useDyspozycjaEdit'

function DyspozycjaEditPage() {
	const { t } = useTranslation()
	const {
		availability,
		formError,
		formState,
		handleBack,
		handleCancel,
		handleFieldChange,
		handleSlotToggle,
		handleEditSubmit,
		hasExistingEntryForRange,
		loadError,
		loading,
		rangeEntriesError,
		saving,
	} = useDyspozycjaEdit()

	if (loading) {
		return <Loading />
	}

	if (!availability) {
		return (
			<div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
				<h1 className="text-lg font-semibold text-gray-900">{t('trainingAvailability.edit.title')}</h1>
				<p className="mt-2 text-sm text-gray-700">{loadError || t('trainingAvailability.details.noData')}</p>
				<button
					type="button"
					onClick={handleBack}
					className="mt-4 inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
					{t('trainingAvailability.details.actions.back')}
				</button>
			</div>
		)
	}

	return (
		<div className="space-y-6">
			<div className="rounded-2xl bg-white p-6 shadow-sm">
				<div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
					<div>
						<h1 className="text-2xl font-semibold text-gray-900">{t('trainingAvailability.edit.title')}</h1>
						<p className="text-sm text-gray-500">{t('trainingAvailability.edit.description')}</p>
					</div>
					<button
						type="button"
						onClick={handleBack}
						className="inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50">
						{t('trainingAvailability.edit.actions.back')}
					</button>
				</div>

				{loadError && <div className="mb-4 rounded-md bg-yellow-50 p-4 text-sm text-yellow-800">{loadError}</div>}
				{rangeEntriesError && <div className="mb-4 rounded-md bg-yellow-50 p-4 text-sm text-yellow-800">{rangeEntriesError}</div>}
				{hasExistingEntryForRange && (
					<div className="mb-4 rounded-md bg-yellow-50 p-4 text-sm text-yellow-800">
						{t('trainingAvailability.edit.messages.duplicateDateRange')}
					</div>
				)}

				<section className="rounded-2xl border border-gray-200 p-4">
					<AvailabilityForm
						formState={formState}
						formError={formError}
						onSubmit={handleEditSubmit}
						onFieldChange={handleFieldChange}
						onSlotToggle={handleSlotToggle}
						onCancel={handleCancel}
						saving={saving}
						submitDisabled={hasExistingEntryForRange}
						mode="edit"
					/>
				</section>
			</div>
		</div>
	)
}

export default DyspozycjaEditPage
